import React from 'react';
import './policies.css'; // Ensure the CSS file is imported

const PublicModConduct = () => {
    return (
        <div className="table-container"> {/* Apply glassmorphism effect */}
            <h1>Moderator Code of Conduct</h1>
            <p>
                Several people have asked how I approach the job of moderation, or have
                had misconceptions about what the job involves.
                For transparency, I am publishing here the Code of Conduct I use to guide
                how I approach the duties of a moderator.
            </p>
            <p>
                <b>Treat everyone with dignity and respect.</b>
                No matter how I may feel about someone personally, or what history they have
                with the game, I should start each conversation assuming the best. I should
                never insult or belittle someone, just because they have done something wrong.
                There are way too many opportunities for miscommunication and the process of
                working that out will go a lot faster if you don't immediately put someone on
                the defensive.
            </p>
            <p>
                <b>Where possible, give everyone multiple chances.</b>
                Most people don't read the rules. Even the obvious rules that apply to all games,
                some people will break because they don't think they are enforced. However,
                many young people play these games, and sometimes they genuinely don't understand
                that something is wrong, or why it is wrong. Everyone makes mistakes. That
                has to be allowed for. If someone owns up to what they did, and promises
                not to do it again, they should be given a second chance.
            </p>
            <p>
                <b>Community is more important than rules.</b>
                The most important thing is that these games foster a community of people
                who are having fun. The rules exist to give a framework of commonly expected
                behavior so that everyone knows what is and is not permitted. It is better
                to let a minor rule be bent if the actions are for the good of the community
                than to strictly enforce the letter of the rule if the result is not good
                for the community.
            </p>
            <p>
                <b>Everyone is owed an explanation.</b>
                Anyone should be able to approach me, at any point, and ask why specific actions
                were taken with regard to their account. I should be able to explain what was
                reported, what data I had to back that up, the specific policy that was in play,
                and the exact action taken.
            </p>
            <p>
                <b>Communication before action.</b>
                Where possible, someone should be contacted before action is taken. This may be
                as simple as changing a nickname to BE_POLITE, LESS_RACISM, or TALK_TO_SASAFRASS.
                Frequently there are misunderstandings that are better worked out through dialog
                than through enforcement. There are, regrettably, some behaviors that have legal
                implications, and immediate action is required. But that should be an exception.
            </p>
            <p>
                <b>Respect privacy between players.</b>
                As moderator, I may know things about players that are not necessarily public
                knowledge. It is my duty to ensure they do not become public knowledge, unless
                the person makes it known themselves. This includes, but is not limited to
                real name, age, gender, account name, ip address, city of residence, and the identity
                of any alts they play.
            </p>
            <p>
                <b>Anonymity in reports.</b>
                It is crucial that people are willing to come to the moderator to report problems.
                To keep the door open, it is vital that the identity of people making reports is
                protected. This ensures that the reported player does not engage in retributive
                actions against the reporter.
            </p>
            <p>
                <b>I serve at the pleasure of the community.</b>
                For some games I was approved for the position.
                In other games there are moderators, but they prefer to remain anonymous. For those I am
                just the "public face" for game moderation. In other cases where there is no community
                approved moderator, I serve as the "stand-in moderator". In all cases, the community is
                welcome, at any time, to start a conversation about selecting a replacement for me. I
                don't intend to do this forever. And should someone else qualified stand up and be
                generally approved by the community, I will gladly step down.
            </p>
            <p>
                <b>I am accountable to Shade.</b>
                If, at any point, someone disagrees with my decisions on any matter, they are welcome
                to bring it to Shade's attention. These are his games. He owns them. He has the final
                word on anything that happens here. In the same way I need to be able to explain any
                actions I take to anyone affected by my decisions, I need to be able to explain any
                and all actions to Shade.
            </p>
        </div>
    );
};

export default PublicModConduct;
